import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import Home from './pages/Home'
import Statistics from './pages/Statistics'
import Map from './pages/Map'
import IntegrationGuide from './pages/IntegrationGuide'
import Layout from './components/Layout'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import PerformanceMonitor from './components/PerformanceMonitor'
import { IframeProvider } from './hooks/useIframe'

function App() {
  useEffect(() => {
    // Register service worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration)
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError)
          })
      })
    }
  }, [])

  return (
    <IframeProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/map" element={<Map />} />
          <Route path="/integration-guide" element={<IntegrationGuide />} />
        </Routes>
        <PWAInstallPrompt />
        <PerformanceMonitor show={false} />
      </Layout>
    </IframeProvider>
  )
}

export default App
